import { useCallback, useRef } from 'react';
// TODO: Use changedFiles in `useEdgeworthData` to optimize on the parsing / processing of documents
export function useGetOrCreateUpnNameMap(documents) {
    var upnNameMap = useRef(new Map());
    var setUpnName = useCallback(function (upn, name) {
        var lowerCaseUpn = upn && upn.toLowerCase();
        if (lowerCaseUpn && !upnNameMap.current.has(lowerCaseUpn)) {
            upnNameMap.current.set(lowerCaseUpn, name);
        }
    }, []);
    var processActivityPerson = useCallback(function (activityPerson) {
        if (!activityPerson ||
            !activityPerson.upn ||
            !activityPerson.displayName) {
            return;
        }
        setUpnName(activityPerson.upn, activityPerson.displayName);
    }, [setUpnName]);
    return useCallback(function () {
        if (documents.length) {
            documents.forEach(function (doc) {
                if (doc.activity) {
                    if (doc.activity.actor) {
                        processActivityPerson(doc.activity.actor);
                    }
                    if (doc.activity.people) {
                        doc.activity.people.forEach(processActivityPerson);
                    }
                }
                // Skip the first activity since we have done it above
                if (doc.recentActivities && doc.recentActivities.length > 1) {
                    for (var i = 1; i < doc.recentActivities.length; i++) {
                        var recentActivity = doc.recentActivities[i];
                        if (recentActivity.actor) {
                            processActivityPerson(recentActivity.actor);
                        }
                        if (recentActivity.people) {
                            recentActivity.people.forEach(processActivityPerson);
                        }
                    }
                }
                if (doc.creatorUpn && doc.creatorName) {
                    setUpnName(doc.creatorUpn, doc.creatorName);
                }
                if (doc.sharedByEmail && doc.sharedByFullUsername) {
                    setUpnName(doc.sharedByEmail, doc.sharedByFullUsername);
                }
            });
        }
        return upnNameMap.current;
    }, [documents, processActivityPerson, setUpnName]);
}
//# sourceMappingURL=useGetOrCreateUpnNameMap.js.map